<template>
    <div>
        <div class="realchangebox" v-show="realconfirmbox">
            <div class="title">是否切换至模拟账户登陆？</div>
            <p>
                点击确定后将退出真实账户，是否需要切换?
            </p>
            <div class="realbtn">
                <div class="realoff" @click="offclick">取消</div>
                <div class="realconfirm" @click="handlemn">确认</div>
            </div>
        </div>

        <div class="mnchangebox" v-show="mnconfirmbox">
            <div class="title">是否切换至真实账户登陆？</div>
            <p>
                点击确定后将退出模拟账户，是否需要切换?
            </p>
            <div class="mnbtn">
                <div class="mnoff" @click="offclick">取消</div>
                <div class="mnconfirm" @click="handlereal">确认</div>
            </div>
        </div>

        <div class="mask" @click="handlemask" :style="{zIndex: !this.$store.state.accountshow? '887' : '2'}" v-show="!this.$store.state.accountshow"></div>
        <div class="isloginTips" v-show="loadingShow">
            <img src="@/assets/loading.png" alt="">
            <p>切换账户中...</p>
        </div>
        <div class="header" :style="{backgroundColor: !this.$store.state.accountshow? '#FFFFFF' : '#F5F5F5',zIndex: !this.$store.state.accountshow? '888' : '885'}">
            <div class="header-left" @click="handleicon">
                <span>{{this.$store.state.realcorrectshow?'金荣中国真实账户':'金荣中国模拟账户'}}</span>
                <img :style="{transform: !this.$store.state.accountshow ? 'rotate(180deg)' : 'rotate(0deg)'}" src="@/assets/icon-down.png" alt="">
            </div>
            <div class="header-right">
                <img class="messages" src="@/assets/message.png" alt="">
                <div :style="note" class="qipao"><span>99</span></div>
            </div>
        </div>
        <div class="header-nav" :style="{zIndex: !this.$store.state.accountshow? '888' : '885'}" v-show="!this.$store.state.accountshow">
            <div class="account">
                <div class="account-item" @click="showrealbox">

                    <div class="account-left">
                        <img class="logo" src="@/assets/logo.png" alt="">
                    </div>

                    <!-- 真实账号 -->
                    <div class="account-right">
                        <div class="account-info">
                            <p>{{this.$store.state.account}}</p>
                            <p>
                                <!-- this.$store.state.login是正常登录时真实账号状态，sessionStorage.getItem（'store'）是app.vue刷新之后传过来给this.realreloadaccount的登录状态 -->
                               {{this.$store.state.login || this.realreloadaccount?headeruser:'未登录'}}
                               <span v-show="this.$store.state.login && headerVip">{{'VIP'+headerVip}}</span>
                            </p>
                        </div>
                        <img class="correct" v-show="this.$store.state.realcorrectshow" src="@/assets/correct.png" alt=""> 
                    </div>

                </div>

                <div class="account-item" @click="showmnbox">

                    <div class="account-left">
                        <img class="logo" src="@/assets/logo.png" alt="">
                    </div>

                    <!-- 模拟账号 -->
                    <div class="account-right">
                        <div class="account-info">
                            <p>{{this.$store.state.mnaccount}}</p>
                            <p>
                                <!-- this.$store.state.mnlogin是正常登录时模拟账号状态，sessionStorage.getItem（'mnstore'）是app.vue刷新之后传过来给this.mnreloadaccount的登录状态 -->
                               {{this.$store.state.mnlogin || this.mnreloadaccount?mnaccounttext:'未登录'}}
                            </p>
                        </div>
                        <img class="correct" v-show="this.$store.state.mncorrectshow" src="@/assets/correct.png" alt="">
                    </div>

                </div>


            </div>
        </div>
    </div>
</template>

<script>
import pako from 'pako'
import axios from 'axios'
import moment from 'moment'
import md5 from 'js-md5';
import {login0,sendText0,start,utf8ByteToUnicodeStr,toBytes} from '@/utils/socket2.js';
export default {
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    name:'headers',
    data(){
        return{
            realconfirmbox:false,
            mnconfirmbox:false,
            mnaccounttext:null,
            text:'金荣中国真实账户',//顶部默认文本
            headeruser:null,
            loadingShow:false,
            headerVip:null,
            level:null,
            realreloadaccount:JSON.parse(sessionStorage.getItem("store")),
            mnreloadaccount:JSON.parse(sessionStorage.getItem("mnstore")),
            // loginSuccess:false,//切换真实账户提示
            // mnloginSuccess:false,//切换模拟账户提示
            accountshow:true,
            note: {backgroundImage: "url(" + require("@/assets/icon01.png") + ")",backgroundRepeat: "no-repeat",backgroundSize: "100% 100%",width:"36px",height:"24px"},
        }
    },
    methods:{

        // 获取账户信息
        getvipinfo(){
            var now = moment().format('YYYY-MM-DD')
            var user = localStorage.getItem('arglogin')
            var md5key = md5(`${user}@sz_$30#JrjR.com${now}`)
            var url = `https://dhapi.jrjrtrade.com:33001/?r=trade/uinfofh5&v=v1&user=${user}&secretkey=`+md5key+`&t=1`
            axios.get(url).then((response) => {
                
                if(response.data.data.user.length<=5){
                    this.headeruser = this.plusXing(response.data.data.user,1,1)
                }else{
                    this.headeruser = this.plusXing(response.data.data.user,2,3)
                }
                this.headerVip = response.data.data.vipnum

            })
        },

        //显示字符串中间加星号
        plusXing (str,frontLen,endLen) {
            var len = str.length-frontLen-endLen;
            var xing = '';
            for (var i=0;i<len;i++) {
                xing+='*';
            }
            return str.substr(0,frontLen)+xing+str.substr(str.length-endLen);
        },

        // 点击导航栏显示隐藏
        handleicon(){
            // 顶部显示隐藏
            this.$store.state.accountshow = !this.$store.state.accountshow
            // mask显示隐藏
            this.$store.state.contentshow = !this.$store.state.contentshow
            this.mnconfirmbox = false //关闭确认框
            this.realconfirmbox = false //关闭确认框
        },

        // 点击mask关闭顶部
        handlemask(){
            this.$store.state.accountshow = !this.$store.state.accountshow
            this.mnconfirmbox = false //关闭确认框
            this.realconfirmbox = false //关闭确认框
        },

        // 点击出现切换真实账户确认框
        showrealbox(){
            if(this.$store.state.mnlogin){ //如果此时是模拟账户状态
                this.mnconfirmbox = true
                this.realconfirmbox = false
            }else if(!this.$store.state.login && !this.$store.state.mnlogin){//如果全部未登录状态
                this.$store.state.contentshow = false //显示真实账户banner
                this.$store.state.realcorrectshow = true //控制图标
                this.$store.state.mncorrectshow = false //控制图标
                this.handleicon()
                this.$store.state.contentshow = !this.$store.state.contentshow //mask显示隐藏
                this.$store.state.accountrealbox = true //真实账户弹框开启
                this.$store.state.accountfalsebox = false //模拟账户弹框关闭
            }
        },

        // 点击出现切换模拟账户确认框
        showmnbox(){
            if(this.$store.state.login){ //如果此时是真实登录状态
                this.realconfirmbox = true
                this.mnconfirmbox = false
            }else if(!this.$store.state.login && !this.$store.state.mnlogin){//如果全部未登录状态
                this.$store.state.contentshow = true //显示模拟账户banner
                this.$store.state.mncorrectshow = true //控制图标
                this.$store.state.realcorrectshow = false //控制图标
                this.handleicon()
                this.$store.state.contentshow = !this.$store.state.contentshow //mask显示隐藏
                this.$store.state.accountfalsebox = true //模拟账户弹框开启
                this.$store.state.accountrealbox = false //真实账户弹框关闭
                
            }
        },

        // 取消切换
        offclick(){
            this.mnconfirmbox = false
            this.realconfirmbox = false
            this.$store.state.accountshow = !this.$store.state.accountshow
        },

        // 点击真实账户
        handlereal(){
            var that = this
            that.$store.state.contentshow = false //显示真实账户banner
            that.$store.state.realcorrectshow = true //控制图标
            that.$store.state.mncorrectshow = false //控制图标
            that.handleicon()

            if(that.$store.state.mnlogin){ //如果此时是模拟账户状态

                if (that.global.ws && that.global.ws.readyState == 1) {

                    that.$store.state.login = false //清除vuex的登录状态，防止连接错乱
                    that.$store.state.mnlogin = false //清除vuex的登录状态，防止连接错乱
                    
                    that.global.ws.close();

                }

                this.$store.state.accountrealbox = true //准备返回login页面时，真实账户弹框开启

                this.$store.state.accountfalsebox = false //准备返回login页面时，模拟账户弹框关闭

                sessionStorage.removeItem("store") //刷新之后如果是模拟账户状态，真实账户为false(清除，等刷新之前会重新获取当前登录状态)
                sessionStorage.removeItem("mnstore") //刷新之后如果是真实账户，模拟账户变false(清除，等刷新之前会重新获取当前登录状态)

                this.$store.state.dealgold = null //切换账号清除商品类(XAU或者GOLD)
                this.$store.state.isprofession = null //切换账号清除是否专业者

                this.$store.state.dealtype = "限价买入" // 70账号切换黄金默认回到限价买入
                this.$store.state.sldealtype = "限价买入" // 70账号切换白银默认回到限价买入 

                that.$router.push({path:'/login'}) //点击真实账户，真实账户登录状态关闭回到login页面

            }
            
        },

        // 点击模拟账户
        handlemn(){
            var that = this
            that.$store.state.contentshow = true //显示模拟账户banner
            that.$store.state.mncorrectshow = true //控制图标
            that.$store.state.realcorrectshow = false //控制图标

            that.handleicon()
            
            if(that.$store.state.login){ //如果此时是真实登录状态

                if (that.global.ws && that.global.ws.readyState == 1) {

                    that.$store.state.login = false //清除vuex的登录状态，防止连接错乱
                    that.$store.state.mnlogin = false //清除vuex的登录状态，防止连接错乱

                    that.global.ws.close();

                }

                this.$store.state.accountfalsebox = true //准备返回login页面时，模拟账户弹框开启

                this.$store.state.accountrealbox = false //准备返回login页面时，真实账户弹框关闭

                sessionStorage.removeItem("store") //刷新之后如果是模拟账户状态，真实账户为false(清除，等刷新之前会重新获取当前登录状态)
                sessionStorage.removeItem("mnstore") //刷新之后如果是真实账户，模拟账户变false(清除，等刷新之前会重新获取当前登录状态)

                this.$store.state.dealgold = null //切换账号清除商品类(XAU或者GOLD)
                this.$store.state.isprofession = null //切换账号清除是否专业者

                this.$store.state.dealtype = "限价买入" // 70账号切换黄金默认回到限价买入
                this.$store.state.sldealtype = "限价买入" // 70账号切换白银默认回到限价买入 

                that.$router.push({path:'/login'}) //点击模拟账户，真实账户登录状态关闭回到login页面

            }

        },
        
    },

    mounted(){
        this.getvipinfo()      
        if(this.$store.state.mnlogin){
            if(localStorage.getItem('mnloginUser').length <= 5){
                this.mnaccounttext = this.plusXing (localStorage.getItem('mnloginUser'),1,1) 
            }else{
                this.mnaccounttext = this.plusXing (localStorage.getItem('mnloginUser'),2,3) 
            }
        }  
    }

}
</script>

<style scoped>
body{touch-action: none;}
.mask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 2;}
.header-nav{background-color: #FFFFFF;position: absolute;top: 44px;left: 0;right: 0;margin: 0 auto;z-index: 885;}
.header{height: 44px;padding: 0px 15px 0 15px;display: flex;justify-content: space-between;align-items: center;position: relative;z-index: 885;}
.header-left{display: flex;align-items: center;}
.header-left span{color: #333333;font-size:16px;font-weight: bold;font-family: 'PingFangSC-Semibold';}
.header-left img{width: 24px;height: 24px;display: block;transition: all 0.5s;}
.header-right{position: relative;display: none;}
.header-right .messages{width: 24px;height: 24px;display: block;}
.header-right .qipao{position: absolute;right: -15px;top: -12px;font-size: 12px;color: #FFFFFF;display: flex;justify-content: center;align-items: center;}

.account{padding: 0 15px;}
.account-item{height: 77.67px;display: flex;justify-content: space-between;align-items: center;}
.account-left{margin-right: 12px;}
.account-left .logo{width: 36px;height: 36px;display: block;}
.account-right{width:100%;display: flex;justify-content: space-between;align-items: center;}
.account-right .account-info p:nth-of-type(1){color: #333333;font-size: 16px;}
.account-right .account-info p:nth-of-type(2){color: #999999;font-size: 14px;display:flex;align-items: center;justify-content: flex-start;}
.account-right .account-info p:nth-of-type(2) span{width: 32px;height: 14px;background-image: linear-gradient(to right, #C5A565, #DFC289);display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 11px;margin-left: 6.67px;border-radius: 7px;}
.correct{width: 24px;height: 24px;display: block;}

.realchangebox{z-index: 999;border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;bottom: 0;left: 0;right: 0;margin: 0 auto;}
.realchangebox .title{text-align: center;padding: 17.67px 0 20.33px 0;color: #333333;font-size: 16px;display: flex;justify-content: center;font-weight: bold;}
.realchangebox p{padding: 0 33.33px 36.33px 20.67px;color: #333333;font-size: 14px;text-align: left;}
.realchangebox .realbtn{height: 44px;padding: 0 20px 49px 20px;display: flex;justify-content: space-between;align-items: center;}
.realchangebox .realbtn .realconfirm{border-radius: 22px;display: flex;justify-content: center;align-items: center;font-weight: bold;font-size: 16px;width: 49%;height: 100%;background-image: linear-gradient(to right, #FF4F36, #FF6738);color: #FFFFFF;}
.realchangebox .realbtn .realoff{border-radius: 22px;display: flex;justify-content: center;align-items: center;font-weight: bold;font-size: 16px;width: 49%;height: 100%;background-color: #EEEEEE;color: #333333;}

.mnchangebox{z-index: 999;border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;bottom: 0;left: 0;right: 0;margin: 0 auto;}
.mnchangebox .title{text-align: center;padding: 17.67px 0 20.33px 0;color: #333333;font-size: 16px;display: flex;justify-content: center;font-weight: bold;}
.mnchangebox p{padding: 0 33.33px 36.33px 20.67px;color: #333333;font-size: 14px;text-align: left;}
.mnchangebox .mnbtn{height: 44px;padding: 0 20px 49px 20px;display: flex;justify-content: space-between;align-items: center;}
.mnchangebox .mnbtn .mnconfirm{border-radius: 22px;display: flex;justify-content: center;align-items: center;font-weight: bold;font-size: 16px;width: 49%;height: 100%;background-image: linear-gradient(to right, #FF4F36, #FF6738);color: #FFFFFF;}
.mnchangebox .mnbtn .mnoff{border-radius: 22px;display: flex;justify-content: center;align-items: center;font-weight: bold;font-size: 16px;width: 49%;height: 100%;background-color: #EEEEEE;color: #333333;}

/* 加载loading */
.isloginTips{width: 150px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 40%;z-index: 889;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;display: flex;justify-content: center;align-items: center;flex-direction: column;}
.isloginTips p{height: 50px;display: flex;align-items: center;}
.isloginTips img{width: 40px;height: 40px;display: block;margin-top: 20px;animation:loading 0.75s linear infinite forwards;}
@keyframes loading {
    0% {
    transform: rotate(0deg);
    }
    100% {
    transform: rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue